import PropTypes from "prop-types";

import { withFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { SuffixAutocomplete, suffixAutocompletePropTypes } from "../SuffixAutocomplete";
import { SUFFIX_SCHEMA_FIELD_NAME } from "./SuffixFormField.schema";

/**
 * SuffixFormField provides support for SuffixAutocomplete component to be used in a Form.
 */

export const SuffixFormField = (props) => {
  const { componentProps, description, disabled, name = SUFFIX_SCHEMA_FIELD_NAME } = props;

  return withFormField(SuffixAutocomplete, { useController: true })(getFormFieldProps());

  function getFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("SuffixFormField__ARIA"),
        ...componentProps,
      },
      description,
      disabled,
      label: i18n("SuffixFormField__LABEL"),
      name,
    };
  }
};

export const suffixFormFieldPropTypes = {
  /** Component props for SuffixAutocomplete component. */
  componentProps: PropTypes.shape(suffixAutocompletePropTypes),

  /** Text to appear above form control and to the right of the label. */
  description: PropTypes.string,

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

SuffixFormField.propTypes = suffixFormFieldPropTypes;
